export const HOW_DO_YOU_FEEL_OPTIONS = [
  {
    label: "very_good",
    value: "Muy bien",
  },
  {
    label: "normal",
    value: "Normal",
  },
  {
    label: "very_bad",
    value: "Muy mal",
  },
];

export const MOODS = {
  happy: "Contento",
  sad: "Triste",
  neutral: "Neutral",
  angry: "Enojado",
  irritated: "Irritado",
  distressed: "Angustiado",
  anxious: "Ansioso",
  indifferent: "Indiferente",
  excited: "Entusiasmado",
};

export const STATUS_OPTIONS = [
  {
    label: "pending",
    value: "Pendiente",
  },
  {
    label: "inprogress",
    value: "En progreso",
  },
  {
    label: "finish",
    value: "Finalizado",
  },
];
